/* eslint-disable no-param-reassign */
export default (state, { payload: { channels } }) => {
  state.currentAccountChannels = Object.fromEntries(channels?.map((channel) => [channel?.token, channel]) ?? []);
};
